import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

import HomePage from './pages/HomePage';
import CasesPage from './pages/CasesPage';
import DetailPage from './pages/DetailPage';
import ReportPage from './pages/ReportPage';
import MapaPage from './pages/MapaPage';
import QuienesSomosPage from './pages/QuienesSomosPage';
import ContactoPage from './pages/ContactoPage';
import NoticiasPage from './pages/NoticiasPage';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/"              element={<HomePage />} />
        <Route path="/casos"         element={<CasesPage />} />
        <Route path="/caso/:id"      element={<DetailPage />} />
        <Route path="/reportar"      element={<ReportPage />} />
        <Route path="/mapa"          element={<MapaPage />} />
        <Route path="/quienes-somos" element={<QuienesSomosPage />} />
        <Route path="/contacto"      element={<ContactoPage />} />
        <Route path="/noticias"      element={<NoticiasPage />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

export default App;
